export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: 'us-east-1',
    BUCKET: 'sha-uploads',
    accessKeyId: '',
    secretAccessKey: '',
  },
  apiGateway: {
    REGION: 'us-east-1',
    // URL: "https://oj2s9juvhh.execute-api.us-east-1.amazonaws.com/nam-production"
    //  URL: "https://nunx9tai34.execute-api.us-east-1.amazonaws.com/nam-dev"
    // URL: "http://localhost:1221"

    // verified below is for sha production on 11/12/2020
    // URL: 'https://umu8ltniff.execute-api.us-east-1.amazonaws.com/stage',

    // verified below is for wl-sha-stage on 02/23/2021
    // URL: 'https://94586ufob4.execute-api.us-east-1.amazonaws.com/wl-sha-stage',

    // verified for uag-portal-stage on 10/22/2021
   // URL: 'https://pra4k9b166.execute-api.us-east-1.amazonaws.com/uag-stage',

    // verfiied for uag-portal-prod on 12/27/2021
    URL: 'https://ll02atk2r9.execute-api.us-east-1.amazonaws.com/uag-prod'
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_UA8icK4Go',
    APP_CLIENT_ID: 'dsbqvpnuajddb0g016c4agj9q',
    IDENTITY_POOL_ID: 'us-east-1:911830d4-64bc-49c7-b2eb-42a4c3d39b88',
  },
  narrasysAM: {
    version: '0.01d-uag-prod', // 4/12/22
  },
};
